module.exports = __webpack_public_path__ + "static/fun-time/games/page000_game2/audio//10_yellow.mp3";